import { ServiceSessionStorageBase } from "@/services/storage/base/service-session-storage-base";
import {
  FileSongData,
  FileSongStorageData,
  LocalSongDataHandler,
} from "@/services/storage/base/storage-abstractions";
import { base64ToBlob, blobToBase64 } from "@/utils/blob-utils";

export class LocalSongDataStorageMixin
  extends ServiceSessionStorageBase
  implements LocalSongDataHandler
{
  private readonly localFileKey = "localFileData";

  async setLocalSongData(localFile: File | null): Promise<void> {
    if (localFile === null) {
      await this.deleteDataDB(this.localFileKey);
      return;
    }

    const base64data = await blobToBase64(localFile);
    const jsonData = JSON.stringify({
      songFile: base64data,
      title: localFile.name,
    });

    await this.saveDataDB(this.localFileKey, jsonData);
  }

  async getLocalSongData(): Promise<FileSongData | null> {
    const jsonLocalFileData = await this.getDataDB(this.localFileKey);
    if (!jsonLocalFileData) {
      return null;
    }

    const localFileData = JSON.parse(jsonLocalFileData) as FileSongStorageData;
    return {
      songFile: new File(
        [base64ToBlob(localFileData.songFile)],
        localFileData.title,
      ),
    };
  }
}
